export const enum Tasks {
  startQuality = '0',
  runQuality = '1',
  lunge = '2',
}
